import ItemsIndexPage from '../../components/pages/items/ItemsIndexPage.vue'

export default {
  components: { ItemsIndexPage }
}
